mutation CreateDocumentMutation($input: CreateDocumentInput!) {
  createDocument(input: $input) {
    id
    title
    slug
    type
  }
}
